export default __webpack_public_path__ + "static/media/reward-2.3479d051.png";